import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="section-container py-12 sm:py-20">
        <Button
          variant="ghost"
          onClick={() => window.history.back()}
          className="mb-8 hover:bg-transparent hover:text-foreground"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>

        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-12">
            Terms of Use
          </h1>

          <div className="space-y-12 text-left">
            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">1. Acceptance of Terms</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                By accessing and using TenderAI's platform, you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">2. Description of Service</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                TenderAI provides AI-powered tender review and bid intelligence services, including document analysis, eligibility checking, compliance mapping, risk assessment, and draft application generation.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">3. User Obligations</h2>
              <p className="text-base text-muted-foreground leading-relaxed mb-4">
                As a user of TenderAI, you agree to:
              </p>
              <ul className="list-disc pl-6 text-base text-muted-foreground leading-relaxed space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Use the service only for lawful purposes</li>
                <li>Not attempt to reverse engineer or compromise our platform</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">4. Intellectual Property</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                All content, features, and functionality of TenderAI, including but not limited to text, graphics, logos, and software, are owned by TenderAI and protected by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">5. Limitation of Liability</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                TenderAI provides AI-assisted analysis and recommendations. While we strive for accuracy, users are responsible for verifying all information and making final decisions regarding tender submissions. We are not liable for bid failures or business decisions made based on our platform's outputs.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">6. Termination</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                We reserve the right to terminate or suspend your account and access to our services at our sole discretion, without notice, for conduct that we believe violates these Terms of Use or is harmful to other users, us, or third parties, or for any other reason.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">7. Changes to Terms</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                We may modify these Terms of Use at any time. Continued use of the platform after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="font-display text-2xl sm:text-3xl mb-4">8. Contact Information</h2>
              <p className="text-base text-muted-foreground leading-relaxed">
                For questions about these Terms of Use, please contact us at:
              </p>
              <p className="text-base text-muted-foreground leading-relaxed mt-4">
                Email: info@smarttenderai.com<br />
                Phone: +44 20 3976 0700<br />
                Address: 3 Shortlands, London W6 8DA, UK
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
